import { render, staticRenderFns } from "./FollowupsProfileSection.vue?vue&type=template&id=1f02e016&scoped=true"
import script from "./FollowupsProfileSection.vue?vue&type=script&lang=js"
export * from "./FollowupsProfileSection.vue?vue&type=script&lang=js"
import style0 from "./FollowupsProfileSection.vue?vue&type=style&index=0&id=1f02e016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f02e016",
  null
  
)

export default component.exports